module.exports = __webpack_public_path__ + "static/media/mySpaceEmpty.da2c9069.png";